<template>
  <!-- To do: Refactor the <EmbeddedNavContainer /> component to support mobile navigation -->
  <div class="embedded-portal-nav" data-cy="embedded-portal-side-nav" :style="appStyleProps">
    <button data-cy="sideNav" class="btn btn-toggle-menu d-lg-none" @click="toggleNav()">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="menu-container d-lg-block"
         :class="{ 'd-block': sidenavToggle, 'd-none': !sidenavToggle, 'mobile-menu-pointer': sidenavToggle }">
      <div class="embedded-portal-nav-content d-block d-lg-flex flex-column">
        <NuxtImg v-if="!!affiliateCustomizations && !iframeHeaderVisible && !!appNavLogo"
             :src="formatImagePath(appNavLogo)"
             alt=""
             class="affiliate-customizations-app-nav-logo"/>
        <nav>
          <ul>
            <li
              class="mb-1"
              v-for="link in navLinksForCurrentApp"
              :key="kebabString(link.title)"
              @mouseover='linkHover = link.title'
              @mouseleave='linkHover = ""'>
              <a v-if="isSignOutLink(link.title)" data-cy="embedded-sign-out" @click="handleSignOut($event)" id="embedded-sign-out">
                <i class="far fa-fw me-2" :class="link.faIcon"></i>
                <span class="nav-text">{{ link.title }}</span>
              </a>
              <nuxt-link
                v-else-if="!userOverride(link.title)"
                :to="link.url"
                :class="{ 'current': link.url === useRoute().path }"
                :data-cy="'side-nav-' + kebabString(link.title)">
                <i class="far fa-fw me-2" :class="link.faIcon"></i>
                <span class="nav-text">{{ link.title }}</span>
              </nuxt-link>
              <a v-else data-cy="user-override" @click="openOverrideModal()" id="user-override">
                <i class="far fa-fw me-2" :class="link.faIcon"></i>
                <span class="nav-text">{{ link.title }}</span>
              </a>
            </li>
          </ul>
        </nav>
        <div class="d-none d-lg-block mt-auto">
          <EmbeddedSupportInfo v-if="contactInfoEnabled" />
          <PoweredByLendio v-if="poweredByLendioEnabled" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EMBEDDED_PORTAL_NAV_TITLES, INTELLIGENT_LENDING_PORTAL_NAV_TITLES } from '~/libs/portal-constants'
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { usePortalStore } from '~/store/portal'
import { useRootStore } from '~/store/root'
import { useUserOverrideStore } from '~/store/user-override'
import EmbeddedSupportInfo from '~/components/embedded/EmbeddedSupportInfo.vue'
import PoweredByLendio from '~/components/PoweredByLendio.vue'
import formatImagePath from '~/libs/image-format'

export default {
  name: 'EmbeddedPortalNav',
  components: {
    EmbeddedSupportInfo,
    PoweredByLendio,
  },
  setup() {
    return { formatImagePath }
  },
  data() {
    return {
      sidenavToggle: false,
      linkHover: '',
    }
  },
  computed: {
    ...mapState(usePortalStore, ['navLinksForCurrentApp']),
    ...mapState(useAffiliateCustomizationStore, [
      'affiliateCustomizations',
      'appNavLogo',
      'appStyleProps',
      'contactInfoEnabled',
      'iframeHeaderVisible',
      'poweredByLendioEnabled',
    ]),
  },
  watch: {
    '$route.path'() {
      this.sidenavToggle = false
    }
  },
  methods: {
    openOverrideModal() {
      useUserOverrideStore(this.$pinia).$patch({ overrideModalOpen: true })
    },
    userOverride(linkTitle) {
      return linkTitle === EMBEDDED_PORTAL_NAV_TITLES.USER_OVERRIDE
    },
    isSignOutLink(linkTitle) {
      return linkTitle === INTELLIGENT_LENDING_PORTAL_NAV_TITLES.SIGN_OUT
    },
    handleSignOut($event) {
      $event.stopPropagation();
      this.logout()
    },
    logout () {
      useRootStore(this.$pinia).logout({ $router: this.$router, path: this.$route && this.$route.path })

      if (typeof window.logout !== 'undefined') {
        window.logout()
      }
    },
    shouldGoToExternalUrl(externalUrlCondition) {
      return this[externalUrlCondition]
    },
    toggleNav() {
      this.sidenavToggle = !this.sidenavToggle
    },
    kebabString(str) {
      return str.replace(/\s/g, '-').toLowerCase()
    },
  },
}
</script>

<style scoped lang="scss">
@import "assets/styles/global";
@import 'assets/styles/affiliate-customizations/affiliate-customization-mixins';
@import 'assets/styles/affiliate-customizations/affiliate-customizations-portal-sidenav';


.embedded-portal-nav {
  @include affiliateCustomizedPortalSidenav();
  .affiliate-customizations-app-nav-logo {
    @include affiliateAppNavLogoPortal();
  }
}
</style>
